import { Navigate, useSearchParams } from 'react-router-dom';
import { LeadsPage } from '@/pages/LeadsPage';
import { PipelinePage } from '@/pages/PipelinePage';

/** `/pipeline` = tablero; `/pipeline?vista=tabla` = la tabla de leads (misma URL de filtros). */
export function PipelineSection() {
  const [params] = useSearchParams();
  return params.get('vista') === 'tabla' ? <LeadsPage /> : <PipelinePage />;
}

/** `/leads?…` sigue funcionando: enlaces antiguos, avisos y favoritos van a la vista de tabla. */
export function LeadsRedirect() {
  const [params] = useSearchParams();
  const p = new URLSearchParams(params);
  p.set('vista', 'tabla');
  return <Navigate to={`/pipeline?${p.toString()}`} replace />;
}
